import { type Theme } from '@mui/material';

export const blackListStyles = {
  pageEyebrow: (theme: Theme) => ({
    display: 'inline-block',
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    letterSpacing: '0.08em',
    fontWeight: 600,
    opacity: 0.85,
  }),
  formSection: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: { xs: theme.spacing(2), sm: theme.spacing(3) },
    background: 'linear-gradient(180deg, #f7fbff 0%, #f4f8fc 100%)',
  }),
  formHeader: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  }),
  formTitle: {
    fontWeight: 600,
    color: '#334155',
  },
  formField: (theme: Theme) => ({
    width: '100%',
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.common.white,
    },
  }),
  formActions: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  }),
  submitButton: (theme: Theme) => ({
    minWidth: 140,
    minHeight: 44,
    textTransform: 'none',
    fontWeight: 700,
    borderRadius: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    alignSelf: 'stretch',
    boxShadow: 'none',
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'auto',
    },
  }),
  submitButtonWrap: (theme: Theme) => ({
    display: 'flex',
    alignSelf: 'stretch',
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'auto',
    },
  }),
  formHint: (theme: Theme) => ({
    flex: 1,
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  }),
  emailText: (theme: Theme) => ({
    fontWeight: 600,
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
  }),
  dateText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  }),
  deleteButton: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  deleteButtonDisabled: (theme: Theme) => ({
    color: theme.palette.action.disabled,
    pointerEvents: 'auto',
  }),
  emptyCell: (theme: Theme) => ({
    py: theme.spacing(4),
    color: theme.palette.text.secondary,
    backgroundColor: '#ffffff',
  }),
} as const;
